import { useEffect, useState } from "react";
import { Upload, X } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import { toast } from "sonner";

export default function ImageUploader({ value, onChange, recommended = "1200×1600 · 3:4", label = "Image", testId, fit = "cover" }) {
  const [natural, setNatural] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [urlInput, setUrlInput] = useState("");

  useEffect(() => {
    if (!value) { setNatural(null); return; }
    const img = new Image();
    img.onload = () => setNatural({ w: img.naturalWidth, h: img.naturalHeight });
    img.onerror = () => setNatural(null);
    img.src = mediaUrl(value);
  }, [value]);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success(`Uploaded — ${data.width || "?"}×${data.height || "?"}px`);
    } catch { toast.error("Upload failed."); }
    setUploading(false);
  };

  return (
    <div data-testid={testId}>
      <label className="adm-label">{label}</label>
      <div className="flex gap-4 items-start">
        <div className="w-24 h-32 bg-cream border border-ink/10 overflow-hidden shrink-0 flex items-center justify-center">
          {value ? <img src={mediaUrl(value)} alt="" className={`w-full h-full ${fit === "contain" ? "object-contain p-1" : "object-cover"}`} /> : <span className="text-ink/30 text-xs">No image</span>}
        </div>
        <div className="flex-1 space-y-2">
          <p className="font-body text-[0.6rem] text-ink/50">Recommended: {recommended}{natural && ` · Uploaded: ${natural.w}×${natural.h}px`}</p>
          <label className="adm-btn-outline w-fit">
            <Upload size={13} /> {uploading ? "Uploading…" : "Upload File"}
            <input type="file" accept="image/*,video/*" className="hidden" onChange={upload} data-testid={`${testId}-file`} />
          </label>
          <div className="flex gap-2">
            <input className="adm-input" placeholder="…or paste image URL" value={urlInput} onChange={(e) => setUrlInput(e.target.value)} />
            <button type="button" className="adm-btn-outline" onClick={() => { if (urlInput) { onChange(urlInput); setUrlInput(""); } }}>Set</button>
          </div>
          {value && <button type="button" onClick={() => onChange("")} className="text-[0.6rem] uppercase tracking-wide2 text-destructive flex items-center gap-1"><X size={11} /> Remove</button>}
        </div>
      </div>
    </div>
  );
}
